<template>
    <account-card-new
        :name="props.name"
        :type="props.type"
    />
</template>

<script lang="ts" setup>
import type { CardType, Store } from "~/types";

const props = defineProps<{
    name: string;
    type: CardType;
    store: Store;
}>();
</script>
